import { useState } from "react";

const FORM_URL = "https://comtock.github.io/api/form/da2l89iamq5jpe1hrvkg";

export default function SubscribeSection() {
  const [status, setStatus] = useState<"idle" | "success" | "error">("idle");
  const [message, setMessage] = useState("");

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const data = new FormData(form);

    const honeypot = String(data.get("website_alt") || "").trim();
    if (honeypot) {
      setStatus("success");
      setMessage("已收到，感谢订阅！我们将第一时间为你推送每日更新与追更提醒。");
      form.reset();
      return;
    }
    data.delete("website_alt");

    const email = String(data.get("email") || "").trim();
    if (!email) {
      setStatus("error");
      setMessage("请填写有效的邮箱地址。");
      return;
    }

    try {
      const res = await fetch(FORM_URL, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(data as unknown as Record<string, string>).toString(),
      });
      const responseText = await res.text();
      let parsed: { code?: string; meta?: { message?: string; detail?: string }; message?: string } | null = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      const serverMsg =
        parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText;
      const isSpam = /spam|form data is spam/i.test(String(serverMsg || ""));

      if (res.ok && parsed?.code === "OK" && !isSpam) {
        setStatus("success");
        setMessage("订阅成功！从今天起，每次更新都会第一时间提醒你。");
        form.reset();
      } else {
        setStatus("error");
        setMessage(isSpam ? "提交未成功，请稍后重试。" : serverMsg || "提交失败，请稍后重试。");
      }
    } catch {
      setStatus("error");
      setMessage("网络异常，请稍后重试。");
    }
  };

  return (
    <section id="subscribe" className="w-full bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6 grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
        <div>
          <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-100 text-accent-800 px-3 py-1 text-xs">
            <i className="ri-mail-send-line"></i>订阅提醒
          </span>
          <h2 className="mt-3 font-heading text-2xl md:text-4xl text-foreground-950">订阅每日更新提醒</h2>
          <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
            留下邮箱，即可开启韩漫yy每日更新与追更提醒服务。每天的连载更新与热门新作会第一时间推送到你，
            让你不错过任何一话，追更更省心。
          </p>
          <div className="mt-6 flex flex-wrap gap-3 text-sm">
            <span className="inline-flex items-center gap-1.5 rounded-full bg-background-50 border border-background-200 px-3 py-1.5 text-foreground-700">
              <i className="ri-check-line text-accent-600"></i>每日更新汇总
            </span>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-background-50 border border-background-200 px-3 py-1.5 text-foreground-700">
              <i className="ri-check-line text-accent-600"></i>热门新作推荐
            </span>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-background-50 border border-background-200 px-3 py-1.5 text-foreground-700">
              <i className="ri-check-line text-accent-600"></i>随时退订
            </span>
          </div>
        </div>

        <div className="rounded-xl border border-background-200 bg-background-50 p-6 md:p-8">
          <h3 className="font-heading text-xl text-foreground-950">开启我的追更提醒</h3>
          <p className="mt-2 text-sm text-foreground-600">填写邮箱即可完成订阅，全程免费。</p>

          <form data-readdy-form onSubmit={handleSubmit} className="mt-5 space-y-4">
            <div className="honeypot-field" aria-hidden="true">
              <label htmlFor="website_alt">网站</label>
              <input
                type="text"
                id="website_alt"
                name="website_alt"
                tabIndex={-1}
                autoComplete="off"
                readOnly
              />
            </div>

            <div>
              <label htmlFor="email" className="block text-sm font-medium text-foreground-800 mb-1.5">
                邮箱地址
              </label>
              <div className="flex flex-col sm:flex-row gap-3">
                <input
                  id="email"
                  name="email"
                  type="email"
                  required
                  placeholder="you@example.com"
                  className="flex-1 w-full rounded-md border border-background-300 bg-background-50 px-4 py-3 text-sm text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-primary-300 transition-shadow"
                />
                <button
                  type="submit"
                  className="whitespace-nowrap rounded-md bg-primary-500 text-background-50 px-5 py-3 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer"
                >
                  <i className="ri-send-plane-line mr-1.5"></i>立即订阅
                </button>
              </div>
            </div>

            {status === "success" && (
              <p className="flex items-start gap-2 rounded-md bg-accent-100 text-accent-800 text-sm px-4 py-3">
                <i className="ri-checkbox-circle-line mt-0.5"></i>{message}
              </p>
            )}
            {status === "error" && (
              <p className="flex items-start gap-2 rounded-md bg-primary-100 text-primary-800 text-sm px-4 py-3">
                <i className="ri-error-warning-line mt-0.5"></i>{message}
              </p>
            )}
          </form>
        </div>
      </div>
    </section>
  );
}